import { render, staticRenderFns } from "./ActivityLogView.vue?vue&type=template&id=2b2ba636&scoped=true"
import script from "./ActivityLogView.vue?vue&type=script&lang=js"
export * from "./ActivityLogView.vue?vue&type=script&lang=js"
import style0 from "./ActivityLogView.vue?vue&type=style&index=0&id=2b2ba636&prod&lang=scss&scoped=true"
import style1 from "./ActivityLogView.vue?vue&type=style&index=1&id=2b2ba636&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2ba636",
  null
  
)

export default component.exports